module.exports = __webpack_public_path__ + "static/media/fixed_voice_navigation_arrow_right.8c19c18b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_navigation_arrow_right.svg
// module id = 3150
// module chunks = 0